import { Tab, TabPanel, TabPanels, Tabs, TabsList } from '@octano/global-ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { Card } from 'reactstrap';
import { TranslationsKeys } from '../../../locales/translations';
import { ContinuousEducationFormDataLoaderProvider } from '../loaders/ContinuousEducationLoader';
import { ContinuousEducationSectionLoader } from './hooks/ContinuousEducationSectionLoader';
import { ContinuousEducationSectionSchedulesLoader } from './hooks/ContinuousEducationSectionSchedulesLoader';
import SectionGeneralTab from './parts/SectionGeneralTab';
import SectionSchedulesTab from './parts/SectionSchedulesTab';
import SectionsEditHeader from './parts/SectionsEditHeader';

enum SectionsEditTab {
  General = 'general',
  Schedules = 'schedules',
}

const SectionsEdit = () => {
  const { sectionId } = useParams<{ sectionId: string }>();
  const { t } = useTranslation(TranslationsKeys.CONTINUOUS_EDUCATION_SECTIONS);

  const [, setSelectedTab] = useState<string | number>(SectionsEditTab.General);

  return (
    <Card className="p-4 mt-2 mx-3">
      <ContinuousEducationSectionLoader
        defaultQuery={sectionId}
        fetchImmediately
      >
        <ContinuousEducationFormDataLoaderProvider fetchImmediately>
          <SectionsEditHeader />
          <Tabs
            defaultTab={SectionsEditTab.General}
            onSelection={setSelectedTab}
          >
            <TabsList>
              <Tab id={SectionsEditTab.General}>
                {t(`tabs.${SectionsEditTab.General}`)}
              </Tab>
              <Tab id={SectionsEditTab.Schedules}>
                {t(`tabs.${SectionsEditTab.Schedules}`)}
              </Tab>
            </TabsList>
            <TabPanels>
              <TabPanel id={SectionsEditTab.General}>
                <SectionGeneralTab />
              </TabPanel>
              <TabPanel id={SectionsEditTab.Schedules}>
                <ContinuousEducationSectionSchedulesLoader
                  defaultQuery={sectionId}
                  fetchImmediately
                >
                  <SectionSchedulesTab />
                </ContinuousEducationSectionSchedulesLoader>
              </TabPanel>
            </TabPanels>
          </Tabs>
        </ContinuousEducationFormDataLoaderProvider>
      </ContinuousEducationSectionLoader>
    </Card>
  );
};

export default SectionsEdit;
